import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M6.026 4.101c0-.36.123-.664.37-.91a1.24 1.24 0 0 1 .912-.37h5.386c.36 0 .663.123.91.37s.37.551.37.912v11.796c0 .36-.123.663-.37.91a1.24 1.24 0 0 1-.912.37H7.307c-.36 0-.664-.123-.911-.37a1.24 1.24 0 0 1-.37-.912V4.101Zm.769.001v11.795a.49.49 0 0 0 .16.353.49.49 0 0 0 .353.16h5.384a.49.49 0 0 0 .353-.16.49.49 0 0 0 .16-.353v-2.306h-2.564v-.768h2.564v-2.436h-2.564V9.62h2.564V7.182h-2.564v-.77h2.564v-2.31a.49.49 0 0 0-.16-.352.49.49 0 0 0-.353-.16H7.308a.49.49 0 0 0-.353.16.49.49 0 0 0-.16.352Z"
    />
  </Svg>
)
export default SvgComponent
